const About = () => {
  return (
    <div className="about-page">
      <div
        className="container-fluid"
        style={{
          backgroundImage: ` url("https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80")`,
          backgroundRepeat: "no-repeat",
          width: "100%",
          backgroundSize: "cover",
          height: "900px",
        }}
      >
        <div class="about">
          <div class="about-div">
            <p>
            🌟 ZenTasker is not just a to-do app. It’s a gentle reminder to breathe, prioritize your mental peace, and navigate through your day with a calm, focused mind.

🌿 Mindfulness, Meet Productivity
ZenTasker transcends the traditional capabilities of task management by integrating mindful practices and productivity. It’s meticulously crafted to bolster your focus and optimize task management, all while ensuring that your mental wellness is never sidelined.

🚀 Unlock a World of Calm Efficiency
Experience a platform that inspires you to not only manage your tasks with ease but to do so with a mindful approach. Your daily to-do list becomes a journey where each task, each checkmark, brings you closer to a more mindful and positive day.

🔮 Your Personal Wellness Journal
Track your positivity, dive into mindfulness exercises, and indulge in content that uplifts and motivates you. ZenTasker is not merely about checking off tasks; it’s about appreciating each moment and fostering a peaceful, productive environment within and around you.

🤝 Join Us on a Journey to Mindful Productivity
Whether it's a simple daily task or a long-term goal, let ZenTasker be your guide to a balanced, mindful approach towards managing your day and nurturing your mental wellness.

Embark on your journey towards a tranquil, productive life with ZenTasker - where your tasks are mindfully managed, and each day is a step towards a more balanced, positive you."


            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
